import { render } from "./ViewPayment.vue?vue&type=template&id=56016680"
import script from "./ViewPayment.vue?vue&type=script&lang=js"
export * from "./ViewPayment.vue?vue&type=script&lang=js"
script.render = render

export default script